import { IDashMatch } from "./dash-match";

export interface IReconciliationItem {
    transplantDate: string,
    donorAlias: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    matches: IDashMatch[]
}